import React from 'react';

import {
  Chip,
  Popover,
  Grid,
  List,
  ListItem,
  ListItemText,
  Icon,
  ListItemSecondaryAction
} from 'e100-react-components';

import { useIntl } from 'react-intl';
import { useMenuState } from 'shared/hooks';
import { useSortingTitle } from '../../hooks';
import { useRouteStationServicesFilterContext } from '../../context';
import { useStyles } from './styles';

import { STATION_SERVICES_SORTING } from '../../constants';

export const SortSelect = () => {
  const { formatMessage } = useIntl();
  const sortingTitle = useSortingTitle();
  const classes = useStyles();
  const { showMenu, handleShowMenu, anchorEl, handleCloseMenu } = useMenuState();
  const {
    setActiveStationsServicesSorting,
    isActiveStationsServicesHightSorting,
    isActiveStationsServicesLowSorting
  } = useRouteStationServicesFilterContext();

  const checkIcon = (
    <ListItemSecondaryAction>
      <Icon
        color="primary"
        kind="done"
        classes={{
          root: classes.icon
        }}
      />
    </ListItemSecondaryAction>
  );

  return (
    <>
      <Chip
        classes={{
          root: classes.chip
        }}
        label={(
          <Grid container wrap="nowrap" alignItems="center" spacing={0}>
            <Grid item>
              {sortingTitle}
            </Grid>
            <Grid item>
              <Icon
                kind={showMenu ? "arrowDropUp" : "arrowDropDown"}
                classes={{
                  root: classes.arrowIcon
                }}
              />
            </Grid>
          </Grid>
        )}
        clickable
        variant="outlined"
        onClick={handleShowMenu}
      />
      <Popover
        open={showMenu}
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <List>
          <ListItem
            button
            onClick={() => {
              setActiveStationsServicesSorting(STATION_SERVICES_SORTING.hight);
              handleCloseMenu();
            }}
          >
            <ListItemText
              primary={formatMessage({ id: 'priceLowHight' })}
              classes={{
                root: classes.listItemText
              }}
            />
            { isActiveStationsServicesHightSorting && checkIcon }
          </ListItem>
          <ListItem
            button
            onClick={() => {
              setActiveStationsServicesSorting(STATION_SERVICES_SORTING.low);
              handleCloseMenu();
            }}
          >
            <ListItemText
              primary={formatMessage({ id: 'priceHightLow' })}
              classes={{
                root: classes.listItemText
              }}
            />
            { isActiveStationsServicesLowSorting && checkIcon }
          </ListItem>
        </List>
      </Popover>
    </>
  );
};
